import { DocumentationTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { isVersionLinkTarget, type LinkedDocumentationTarget } from 'shared/domain/issue/linkedDocumentation';

/** Tells that the issue was linked to a documentation, or to one version of it (PT-7117). */
export function linkedToDocumentationToastKey(target: LinkedDocumentationTarget): TranslationKey {
  if (isVersionLinkTarget(target)) {
    return DocumentationTranslationKeys.linkedToVersionToast;
  }
  return DocumentationTranslationKeys.linkedToDocumentationToast;
}
